import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { loadCheckoutWebComponents, CardScheme } from '@checkout.com/checkout-web-components';

import { PATH } from '../../../../constants/path';
import { theme } from '../../../../style/constants';
import { APPLICATION_LOCALE, CHECKOUT_API_KEY } from '../../../../constants';

import { useCheckoutFlow } from './CheckoutFlowContext';

import { payWithCheckoutFlow } from '../../../../services/checkout/utils';

import { LoadingComponent } from '../../../loading/LoadingComponent';

import { Wrapper } from './CheckoutStyle';

const CheckoutFlowForm = ({ userInfo, partnerId, order, i18n }) => {
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);
    const [FlowPaymentSession, setFlowPaymentSession] = useState(null);

    const { setIsValid, flowComponentRef, resetFlow } = useCheckoutFlow();

    const processFlowPayment = async () => {
        return payWithCheckoutFlow(userInfo, partnerId, order.id);
    };

    const appearance = {
        colorAction: theme.primary,
        colorBorder: 'transparent',
        colorDisabled: theme.inactive,
        colorError: theme.error,
        colorFormBackground: theme.white,
        colorFormBorder: theme.grey,
        colorPrimary: theme.black,
        colorSuccess: theme.success,
        footnote: {
            fontFamily: theme.fontStackCommon,
            fontSize: '12px',
            fontWeight: 400,
            letterSpacing: 0,
            lineHeight: 'normal'
        },
        label: {
            fontFamily: theme.fontStackCommon,
            fontSize: '14px',
            fontWeight: 400,
            letterSpacing: 0,
            lineHeight: 'normal'
        },
        input: {
            fontSize: '14px'
        },
        borderRadius: ['0px', '0px'],
        focusOutlineWidth: '0px'
    };

    const componentOptions = {
        card: {
            data: {
                cardholderName: `${userInfo.firstname} ${userInfo.lastname}`
            },
            displayCardholderName: 'bottom'
        },
        flow: {
            showPayButton: false,
            acceptedCardSchemes: [
                CardScheme.CartesBancaires,
                CardScheme.Visa,
                CardScheme.Mastercard
            ]
        }
    };

    useEffect(() => {
        (async () => {
            try {
                let paymentSession = FlowPaymentSession;
                if (!paymentSession) {
                    paymentSession = await processFlowPayment();
                    setFlowPaymentSession(paymentSession);
                }

                const environment = CHECKOUT_API_KEY.includes('_sbox_') ? 'sandbox' : 'production';
                const orderId = order.id;
                const checkout = await loadCheckoutWebComponents({
                    publicKey: CHECKOUT_API_KEY,
                    environment,
                    locale: APPLICATION_LOCALE,
                    paymentSession,
                    appearance,
                    componentOptions,
                    onPaymentCompleted: (_component, paymentResponse) => {
                        console.log('Payment completed : ', paymentResponse);
                        const successUrl = `${PATH.EBON_CONFIRMATION_PATH}?orderId=${order.id}&cko-payment-id=${paymentResponse.id}`;
                        window.location.href = successUrl;
                    },
                    onChange: component => {
                        setIsValid(component.isValid());
                    },
                    onError: (component, error) => {
                        console.log('onError', error, 'Component', component);
                        const errorUrl = `${PATH.EBON_ERROR_PATH}-${partnerId}?paiement=error&orderId=${orderId}`;
                        window.location.href = errorUrl;
                    }
                });
                const flowComponent = checkout.create('flow');
                flowComponentRef.current = flowComponent;
                flowComponent.mount('#flow-container');
            } catch (error) {
                console.error('error while loading Checkout Flow : ', error);
                setError(true);
            } finally {
                setLoading(false);
            }
        })();

        // Réinitialise l'état partagé quand le formulaire est démonté
        // (ex. l'utilisateur change de moyen de paiement).
        return () => {
            resetFlow();
        };
    }, []);

    return (
        <Wrapper>
            {loading && (
                <div className="loading-wrapper">
                    <LoadingComponent />
                </div>
            )}

            <div id="flow-container" />

            {error && <p className="error-message">{i18n.ERROR_SESSION}</p>}
        </Wrapper>
    );
};

CheckoutFlowForm.propTypes = {
    userInfo: PropTypes.object,
    partnerId: PropTypes.number,
    order: PropTypes.object,
    i18n: PropTypes.object
};

const mapStateToProps = state => ({
    i18n: state.i18n.CHECKOUT.FLOW
});

export default connect(mapStateToProps)(CheckoutFlowForm);



// WEBPACK FOOTER //
// ./src/components/funnel/payment-step/checkout-flow/CheckoutFlowForm.js